import { gql } from "@apollo/client";
import {
    CONSOLIDATION_TASK_SUMMARY_FIELDS,
    ConsolidationTaskStatus,
    ConsolidationTaskSummary,
    ConsolidationTotalStats,
    Pagination
} from "../types/ConsolidationTypes";

export const GET_CONSOLIDATION_TASKS = gql`
    query GetConsolidationTasks(
        $pageRequest: PageRequestTypeInput
        $filters: ConsolidationTaskFiltersInputTypeInput!
    ) {
        getConsolidationTasks(
            pageRequest: $pageRequest
            filters: $filters
        ) {
            tasks {
                ...ConsolidationTaskSummaryFields
            }
            pagination {
                page
                size
                totalElements
                totalPages
            }
            totalStats {
                totalTaskCount
                activeTaskCount
                totalParcelCount
                totalBagCount
            }
        }
    }
    ${CONSOLIDATION_TASK_SUMMARY_FIELDS}
`;

export interface GetConsolidationTasksVariables {
    pageRequest?: {
        page: number;
        size: number;
        sortBy?: string;
        sortDirection?: 'ASC' | 'DESC';
    };
    filters: {
        warehouseId: string;
        status?: ConsolidationTaskStatus;
        createdAtStart?: string;
        createdAtEnd?: string;
        hubName?: string;
        whsName?: string;
        taskNameSearch?: string;
        carrierCode?: number; // 新增Carrier筛选字段
        type?: number;
    };
}

export interface GetConsolidationTasksResponse {
    getConsolidationTasks: {
        tasks: ConsolidationTaskSummary[];
        pagination: Pagination;
        totalStats: ConsolidationTotalStats;
    };
} 